import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import StartChat from '../Chat/StartChat/index.jsx';
import CustomIcon from '../../../../../../assets/images/CustomIcon';
import { IconScroltToDownHoc } from '../../../../../../assets/images';
import { getChatMessageHistoryById } from '../../../../../../Helpers/Chat/ChatHelper';

const hasOverflow = el => el.clientHeight < el.scrollHeight
const isScrolledDownFunc = (el, threshold) => {
    const bottom = el.scrollTop + el.clientHeight
    return bottom >= el.scrollHeight - threshold
}
const isScrolledUpFunc = el => el?.scrollTop === 0
const scrollDown = el => el.scrollTop = el.scrollHeight - el.clientHeight
const scrollDownBy = (amount, el) => el.scrollTop += amount;


const ScrollHOC = Component => React.memo((props) => {

    const State = useSelector(state => state);
    const { dynamicIcon = {}, activeChatData: { data: activeChatData = [] } } = State;
    const { mf_IconScroltToDown } = dynamicIcon?.data;
    const chatMessages = getChatMessageHistoryById(activeChatData[0]?.chatId);
    const [otfChatMessages, setOtfchatMessages] = useState(chatMessages || []);
    const [isScrolledDown, setIsScrolledDown] = React.useState(true)
    const [scrollContainner, setScrollContainner] = React.useState(null)
    const [scrollHeight, setScrollHeight] = React.useState(null)
    const [isVisibleScroll, setIsVisibleScroll] = React.useState(false)
    const [isScrolledUp, setIsScrolledUp] = React.useState(null)

    window.addEventListener('resize', () => {
        updateHeigth()
    });
    const {
        containerId = "message-containner",
        onScrolledBottom = () => { },
        onScrolledTop = () => { },
        scrollToBottom = () => { },
    } = props;

    const isScrolledDownThreshold = 100

    const scrollDownIfNeeded = () => {
        if (isScrolledDown && scrollContainner && hasOverflow(scrollContainner)) {
            scrollDown(scrollContainner)
        }
    }


    const updateHeigth = () => {
        const container = document.getElementById(containerId);
        if (!container) return;
        const header = document.querySelector('.conversation-header')
        const containerChildren = Array.from(document.querySelectorAll('.chatconversation-container > *:not(.msg-content), .emojiPicker-container')).reduce(function getSum(total, num) {
            return total + Math.round(num.clientHeight);
        }, 0);
        const windowHeights = window.innerHeight;
        const finalHeigth = windowHeights - header.clientHeight - containerChildren
        container.style.height = finalHeigth + "px";
        container.style['overflow-y'] = 'auto';
        container.setAttribute('visibleheight', finalHeigth)
    }
    const handleScroll = (event) => {
        const { target } = event
        if (target.offsetHeight + target.scrollTop === target.scrollHeight) {
            onScrolledBottom()
        }
        setIsScrolledDown(isScrolledDownFunc(scrollContainner, isScrolledDownThreshold))
        if (isScrolledUpFunc(scrollContainner)) {
            setScrollHeight(scrollContainner.scrollHeight)
            onScrolledTop && onScrolledTop(event)
        }
        if (target.offsetHeight + target.scrollTop >= target.scrollHeight - 150) {
            setIsVisibleScroll(false)
        } else {
            setIsVisibleScroll(true)
        }
    }



    React.useEffect(() => {
        updateHeigth()
        scrollDownIfNeeded()
        
        /**
        // const mesgTypingEle = document.getElementById('typingContainer');
        // if (mesgTypingEle) {
        //     new ResizeObserver(() => {
        //        scrollDownIfNeeded();
        //        updateHeigth();
        //        isScrolledDown && scrollContainner && scrollDownBy(30, scrollContainner);
        //     }).observe(mesgTypingEle);
        // }
        */
    });

    React.useEffect(() => {
        setIsScrolledUp(isScrolledUpFunc(scrollContainner))
        if (isScrolledUp && scrollHeight !== null) {
            const difference = scrollContainner.scrollHeight - scrollHeight
            // setScrollHeight(null)
            scrollDownBy(difference, scrollContainner)
        }
    });
    return (
        <React.Fragment>
            <div
                onScroll={e => handleScroll(e)}
                ref={el => setScrollContainner(ReactDOM.findDOMNode(el))}
                id={containerId}
                className={containerId} >
                {
                    chatMessages?.filter(obj => { if (obj?.msgBody?.message_type) return obj }).length > 0 ? <>
                        <div className="extraSpace"></div>
                        <div >
                            <Component
                                {...props}
                            />
                        </div>
                        <span id="InBottom" className="InBottom"></span>
                        {isVisibleScroll &&
                            <div className="more-messages" onClick={scrollToBottom}>
                                {/** {this.state.msgCount && <span className="count-unread">
                                <span>100+</span>
                            </span>
                            } */}
                                <CustomIcon
                                    icon={mf_IconScroltToDown ? mf_IconScroltToDown : <IconScroltToDownHoc viewBox="0 0 41 41" />}
                                    {...props}
                                />
                            </div>
                        }
                    </>
                        :
                        <>
                            <StartChat />
                        </>

                }
            </div>
        </React.Fragment>
    )
})

export default ScrollHOC